import { Pagination, StatusMessageResponse } from '@shared/models';

export interface FetchFMFListResponse extends StatusMessageResponse {
  order_list: FMFListItemResponse[];
  pagination: Pagination;
}

export interface FMFListItemResponse {
  id: number;
  patient: string;
  product: string;
  establishment: string;
  email: string;
  phone_number: string;
  order_creation_date: string;
}
